import { render, staticRenderFns } from "./Verify.vue?vue&type=template&id=47c685d2";
import script from "./Verify.vue?vue&type=script&lang=js";
export * from "./Verify.vue?vue&type=script&lang=js";
import style0 from "./Verify.vue?vue&type=style&index=0&id=47c685d2&prod&lang=css";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;